module.exports = __webpack_public_path__ + "static/media/varie10.5f0f90cf.jpg";